import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import WhatsAppButton from './WhatsAppButton.jsx';

function MobileNav() {
  const location = useLocation();

  const menuItems = [
    { title: 'الرئيسية', path: '/', icon: 'fa-home' },
    { title: 'خدماتنا', path: '/services', icon: 'fa-list-check' },
    { title: 'المقالات', path: '/blog', icon: 'fa-newspaper' },
    { title: 'باقاتنا', path: '/packages', icon: 'fa-box-open' },
    { title: 'من نحن', path: '/about', icon: 'fa-users' }
  ];

  return (
    <AnimatePresence mode="wait">
      <motion.div
        className="fixed bottom-0 left-0 right-0 md:hidden z-50"
        initial={{ y: 50 }}
        animate={{ y: 0 }}
        exit={{ y: 50 }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
      >
        <div
          className="bg-card border-t border-secondary/15 backdrop-blur-md will-change-transform shadow-lg"
          style={{ paddingBottom: 'calc(6px + env(safe-area-inset-bottom, 0px))' }}
        >
          <nav className="container mx-auto px-4 py-1">
            <div className="flex items-center justify-around">
              {menuItems.map((item) => (
                <motion.div
                  key={item.path}
                  whileTap={{ scale: 0.92 }}
                  className="flex flex-col items-center"
                >
                  <Link
                    to={item.path}
                    className="flex flex-col items-center gap-1 px-3 py-1.5 relative group"
                    aria-label={item.title}
                  >
                    <div className={`w-11 h-11 rounded-2xl flex items-center justify-center transition-transform duration-200 will-change-transform ${location.pathname === item.path
                      ? 'bg-secondary text-primary'
                      : 'text-light'
                      }`}>
                      <i className={`fas ${item.icon} text-lg`}></i>
                    </div>
                    <span className={`text-[10px] font-semibold transition-colors duration-200 ${location.pathname === item.path
                      ? 'text-secondary'
                      : 'text-light/70'
                      }`}>
                      {item.title}
                    </span>
                  </Link>
                </motion.div>
              ))}

              <motion.div whileTap={{ scale: 0.92 }} className="flex flex-col items-center">
                <WhatsAppButton />
              </motion.div>
            </div>
          </nav>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}

export default MobileNav;